import { Box, Grid, Paper, createStyles, makeStyles } from '@material-ui/core';
import { colors } from 'design-system';
import { TooltipProps } from 'recharts';

// models
import SalesTrend from 'src/models/Chart/SalesTrend';

// helpers
import getPercentageGrowthColor from './getPercentageGrowthColor';

const useStyle = makeStyles(() =>
  createStyles({
    tooltip: {
      padding: '8px',
      color: colors.abbey,
      zIndex: 20,
      width: '190px',
    },
    toolTiptriangle: {
      fontSize: 25,
      marginRight: '-5px',
      color: 'white',
      textShadow: '-2px 4px 10px rgba(152, 150, 150, 1)',
    },
  }),
);

const createCustomTooltip = (
  selectedLine: string,
): (({ active, payload }: TooltipProps<number, string>) => JSX.Element) => {
  return ({ active, payload }: TooltipProps<number, string>): JSX.Element => {
    const classes = useStyle();
    if (!active || !selectedLine || !payload) {
      return <></>;
    }

    const selectedDataSet = payload.find(
      ({ dataKey }) => dataKey === selectedLine,
    );

    if (!selectedDataSet) {
      return <></>;
    }

    const { color, dataKey: productType } = selectedDataSet;

    const selectedSalesTrend = selectedDataSet.payload as SalesTrend;

    const percentageGrowth = selectedSalesTrend[
      `${productType}Growth`
    ] as number;
    const textPercentageGrowth = `${
      percentageGrowth > 0 ? '+' : ''
    }${percentageGrowth}%`;

    return (
      <Box display="flex" alignItems="center">
        {/* eslint-disable no-irregular-whitespace */}​
        <span className={classes.toolTiptriangle}>&#9664;</span>
        <Paper className={classes.tooltip}>
          <Grid
            container
            style={{
              borderLeft: `2px solid ${color}`,
              fontWeight: 700,
              fontSize: '13px',
              paddingLeft: '8px',
            }}
          >
            <Grid item xs={12}>
              <span style={{ color }}>
                {selectedSalesTrend[`${productType}`]}
              </span>{' '}
              pólizas vendidas
            </Grid>
            <Grid item xs={12}>
              <span
                style={{ color: getPercentageGrowthColor(percentageGrowth) }}
              >
                {textPercentageGrowth}
              </span>{' '}
              que el mes anterior
            </Grid>
          </Grid>
        </Paper>
      </Box>
    );
  };
};

export default createCustomTooltip;
